export const gridColumnMenuSelector = state => state.columnMenu;


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/features/columnMenu/columnMenuSelector.js
// module id = 637
// module chunks = 25